import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { getCheckedIdsArr } from 'utils';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addUerToContractChange } from '../AgreementsQueries';

const TITLE_ADD_ERROR = 'Добавление расценки из прейскуранта расценок';

export const useAddUerAgreements = ({
    agreementId,
    checkedIds,
    refreshData,
    refreshFilters,
    closeAddModalHandler,
}: {
    agreementId: number;
    checkedIds: Record<string, boolean>;
    refreshData: () => void;
    refreshFilters: () => void;
    closeAddModalHandler: () => void;
}) => {
    const dispatch = useDispatch();
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

    const [addUerToAgreementsData, addUerToAgreementsStatus, addUerToAgreementsErr, addUerToAgreementsRequest] =
        useRequest({ requestId: 'addUerToAgreements', query: addUerToContractChange, withEffect: false });

    const handleAddUerAgreements = useCallback(() => {
        const uerRowIds = getCheckedIdsArr(checkedIds);

        dispatch(
            addUerToAgreementsRequest({
                contractChangeId: agreementId,
                uerBaseRowIds: uerRowIds,
            }),
        );

        setIsSubmitted(true);
    }, [addUerToAgreementsRequest, agreementId, checkedIds, dispatch]);

    useEffect(() => {
        if (
            isSubmitted &&
            addUerToAgreementsStatus === RequestStatus.SUCCESS &&
            addUerToAgreementsData?.uerAddUersToContractChange?.result
        ) {
            setIsSubmitted(false);
            refreshData();
            closeAddModalHandler();
            refreshFilters();
        }
    }, [
        addUerToAgreementsData?.uerAddUersToContractChange?.result,
        addUerToAgreementsStatus,
        closeAddModalHandler,
        isSubmitted,
        refreshData,
        refreshFilters,
    ]);

    const handleCloseErrorModalAddMtr = useCallback(() => {
        setIsSubmitted(false);
    }, []);

    const handleCreateReportAddMtr = () => {
        ExportCSVReport(addUerToAgreementsData?.uerAddUersToContractChange?.validation);
    };

    return {
        titleAddError: TITLE_ADD_ERROR,
        addUerAgreementsData: addUerToAgreementsData?.uerAddUersToContractChange,
        addUerAgreementsStatus: addUerToAgreementsStatus,
        addUerAgreementsError: addUerToAgreementsErr,
        isSubmittedAddMtr: isSubmitted,
        handleAddUerAgreements,
        handleCloseErrorModalAddUer: handleCloseErrorModalAddMtr,
        handleCreateReportAddUer: handleCreateReportAddMtr,
    };
};
